import { useEffect, useRef } from "react";

export function useSearchShortcut<T extends HTMLInputElement = HTMLInputElement>() {
  const ref = useRef<T | null>(null);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      const isFindKey = (e.ctrlKey || e.metaKey) && e.key.toLowerCase() === "f";
      if (!isFindKey) return;
      const input = ref.current;
      if (!input) return;
      e.preventDefault();
      input.focus();
      input.select();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return ref;
}
